import { useMutation } from 'react-relay';

import { requestHometaxBlockNotificationMutation } from '@/__generated__/requestHometaxBlockNotificationMutation.graphql';
import { requestHometaxBlockNotification } from '@/graphql/mutation/taxRefund/request-hometax-block-notification';

const useHometaxBlockNotification = () => {
  const [commit, isInFlight] = useMutation<requestHometaxBlockNotificationMutation>(requestHometaxBlockNotification);
  return { commit, isInFlight };
};

export default useHometaxBlockNotification;
